<!-- // ============================================
// 4. ProductPriceSection.vue
// ============================================ -->
<template>
    <div class="price-section">
        <div v-if="product.sales_type === 'fixed'">
            <div class="price-main">
                <div class="price-label">{{ $t('product.price') }}</div>
                <span
                    :class="acceptedOffers.length>0&&product.fixed_price > acceptedOffers[0]?.price ? 'text-decoration-line-through text-muted' : ''">
                    {{ product.fixed_price | currency(' DA', 0, { symbolOnLeft: false }) }}
                </span>
                <span v-if="acceptedOffers.length>0&&product.fixed_price > acceptedOffers[0]?.price" class="ml-2"
                    :class="sortedOffers[0]?.status !== 1 ? 'text-decoration-line-through text-danger' : 'text-success'">
                    {{ acceptedOffers.length>0 && acceptedOffers[0]?.price | currency(' DA', 0, { symbolOnLeft: false }) }}
                </span>
                <AlgerianPriceReaderFR v-if="priceLang == 'fr'" :price="computedMinFixedPrice" />
                <AlgerianPriceReader v-else :price="computedMinFixedPrice" />
            </div>
        </div>
        <div v-else>
            <div class="row">
                <div class="col-6">
                    <div class="price-label">{{ $t('sentence.currentBid') }}</div>
                    <div class="row align-items-center ml-1">
                        <div class="price-main mr-2">{{ formatPrice(product.price) }}</div>
                        <AlgerianPriceReaderFR v-if="priceLang == 'fr'" :price="product.price" />
                        <AlgerianPriceReader v-else :price="product.price" />
                    </div>
                </div>
                <div class="col-6">
                    {{ product.bids.length }} {{ $t('ecommerce.bids') }}
                    <span v-if="product.bids.length > 5" class="d-block text-primary mr-3 mt-1 font-weight-bold">
                        <i class="mdi mdi-fire-circle"></i> {{ $t('sentence.popular') }}
                    </span>
                    <div v-if="$route.name !== 'ProductManagement'">
                        <span class="d-block font-weight-bold mr-3 mt-1" v-if="user.username || true">
                            {{ $t('ecommerce.myBestOffer') }}: {{ formatPrice(product.user_best_bid?.price) }}
                        </span>
                        <span class="d-block font-weight-bold mr-3 mt-1" v-if="user.username || true">
                            {{ $t('ecommerce.autobid') }}: {{ formatPrice(product.last_auto_bid?.autobid_max) }}
                            <i @click="$emit('delete-auto-bid', product.last_auto_bid.id)" class="mdi mdi-delete"
                                style="cursor: pointer;"></i>
                        </span>
                    </div>
                </div>
                <div class="col-md-6 font-weight-bold"
                    :class="product.time_left > 60 * 60 * 24 ? 'text-secondary' : 'text-danger'">
                    <i class="mdi mdi mdi-clock-time-four"></i>
                    <span v-if="product.time_left > 0">{{ $t('auction.ends_in') }}</span>
                    <TimerSimpleLong :timeLeft="product.time_left" :deadline="product.validated || 'Null'"
                        :duration="product.duration" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AlgerianPriceReader from "@/components/templates/AlgerianPriceReader.vue";
import AlgerianPriceReaderFR from "@/components/templates/AlgerianPriceReaderFR.vue";
import TimerSimpleLong from '@/components/templates/TimerSimpleLong.vue';
import helper from "@/services/helper";

export default {
    name: 'ProductPriceSection',
    components: {
        AlgerianPriceReader,
        AlgerianPriceReaderFR,
        TimerSimpleLong,
    },
    props: {
        product: {
            type: Object,
            required: true
        },
        sortedOffers: {
            type: Array,
            default: () => []
        },
        priceLang: {
            type: String,
            default: 'ar'
        },
        user: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        computedMinFixedPrice() {
            const fixed=Number(this.product?.fixed_price??Infinity);
            const bestOffer=Number(this.sortedOffers?.[0]?.price??Infinity);
            return Math.min(fixed, bestOffer);
        },
        acceptedOffers() {
            return this.sortedOffers.filter(o => o.status===1);
        }
    },
    methods: {
        formatPrice: helper.formatPrice
    }
};
</script>

<!-- 4. ProductPriceSection.vue -->
<style scoped>
.price-section {
    background: var(--color-e);
    padding: 20px;
    border-radius: 8px;
    margin-top: 20px;
    margin-bottom: 20px;
    border: 1px solid #ffe5d9;
}

.price-label {
    font-size: 14px;
    color: var(--color-6);
    margin-bottom: 5px;
}

.price-main {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 10px;
}

@media (max-width: 768px) {
    .price-main {
        font-size: 28px;
    }

    .price-section {
        margin-top: 0px;
    }
}

@media (max-width: 576px) {
    .price-main {
        font-size: 24px;
    }
}
</style>
